module.exports = __webpack_public_path__ + "static/media/outline-format_align_left-24px.1b7fb0f2.svg";